import {useNavigate} from "react-router-dom";
import './event-preview.scss';
import {AWS_S3_BUCKET, EVENT_POSTER_IMAGE_PREFIX} from "../../../../global_vars";
import * as querystring from "node:querystring";

interface EventPreviewProps {
    id: number | null;
    name: string;
    description: string;
    address: string;
    date: Date;
    eventCode: string;
}

function EventPreview({id, name, description, address, date, eventCode}: EventPreviewProps) {

    const navigate = useNavigate();
    const poster_url = `${AWS_S3_BUCKET}/${EVENT_POSTER_IMAGE_PREFIX}${eventCode}.jpg`;

    const navigateToEvent = () => {
        console.log("POSTER URL: ", poster_url);
        navigate(`/event/${eventCode}`);
    }


    return (
        <div className="card event-preview">
            <button className='event-card-btn'
                    style={{backgroundImage: `url(${poster_url})`}}
                    onClick={navigateToEvent}>
                <h2 className={"event-card-name"}>{name}</h2>
                <h4>{address}</h4>
                <h4>{date.toDateString()}</h4>
            </button>
        </div>
    );
}

export default EventPreview;